import React, { useEffect, useState } from "react";
import PageTitle from "../../../jsx/layouts/PageTitle";

const initialForm = {
  type: "page",
  page: "",
  reference: "",

  meta_title: "",
  meta_description: "",
  meta_keywords: "",

  og_type: "website",
  og_url: "",
  og_title: "",
  og_description: "",
  og_image: "",
  og_image_width: "",
  og_image_height: "",
  og_image_alt: "",
  og_locale: "en_US",
  og_site_name: "",

  twitter_card: "summary_large_image",
  twitter_title: "",
  twitter_description: "",
  twitter_image: "",
  twitter_image_alt: "",
  telugu_keywords: "",
telugu_content: "",
faq_schema: "",
robots_content: "index, follow",
schema_markup: "",
};

const pageOptions = [
  "home",
  "about",
  "faq",
  "media",
  "blogs",
  "contact",
  "services",
  "appointment",
];

const SeoDashboard = () => {
  const [seoList, setSeoList] = useState([]);
  const [form, setForm] = useState(initialForm);
  const [editingId, setEditingId] = useState(null);

  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  useEffect(() => {
    fetchSeoList();
  }, []);

  const fetchSeoList = async () => {
    try {
      const res = await fetch("https://admin.drgargevascular.com/backend/seo");
      const data = await res.json();

      if (Array.isArray(data)) {
        setSeoList(data);
      } else {
        setSeoList([]);
      }
    } catch (error) {
      console.error("Error fetching SEO list:", error);
      setSeoList([]);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "type" && {
        page: "",
        reference: "",
      }),
    }));
  };

  const resetForm = () => {
    setForm(initialForm);
    setEditingId(null);
  };

  const showMessage = (msg, type = "success") => {
    setMessage(msg);
    setMessageType(type);

    setTimeout(() => {
      setMessage("");
      setMessageType("");
    }, 4000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.type === "page" && !form.page) {
      return showMessage("Please select a page.", "error");
    }

    if ((form.type === "service" || form.type === "blog") && !form.reference) {
      return showMessage(
        form.type === "service"
          ? "Please enter service slug."
: "Please enter blog slug.",
        "error"
      );
    }

    try {
      const url = editingId
        ? `https://admin.drgargevascular.com/backend/seo/${editingId}`
        : "https://admin.drgargevascular.com/backend/seo";

      const method = editingId ? "PUT" : "POST";

      const payload = {
  type: form.type,
  page: form.type === "page" ? form.page : "",
  reference: form.type !== "page" ? form.reference : "",

  meta_title: form.meta_title,
  meta_description: form.meta_description,
  meta_keywords: form.meta_keywords,

  og_type: form.og_type,
  og_url: form.og_url,
  og_title: form.og_title,
  og_description: form.og_description,
  og_image: form.og_image,
  og_image_width: form.og_image_width,
  og_image_height: form.og_image_height,
  og_image_alt: form.og_image_alt,
  og_locale: form.og_locale,
  og_site_name: form.og_site_name,

  twitter_card: form.twitter_card,
  twitter_title: form.twitter_title,
  twitter_description: form.twitter_description,
  twitter_image: form.twitter_image,
  twitter_image_alt: form.twitter_image_alt,
  telugu_keywords: form.telugu_keywords,
telugu_content: form.telugu_content,
faq_schema: form.faq_schema,
robots_content: form.robots_content,
schema_markup: form.schema_markup,
};

      const res = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Failed to save SEO");
      }

      showMessage(
        editingId ? "SEO updated successfully!" : "SEO added successfully!",
        "success"
      );

      resetForm();
      fetchSeoList();
    } catch (error) {
      console.error("Error saving SEO:", error);
      showMessage(error.message || "Something went wrong while saving SEO.", "error");
    }
  };

  const handleEdit = (seo) => {
    setEditingId(seo.id);

    setForm({
  type: seo.type || "page",
  page: seo.page || "",
  reference: seo.reference || "",

  meta_title: seo.meta_title || "",
  meta_description: seo.meta_description || "",
  meta_keywords: seo.meta_keywords || "",

  og_type: seo.og_type || "website",
  og_url: seo.og_url || "",
  og_title: seo.og_title || "",
  og_description: seo.og_description || "",
  og_image: seo.og_image || "",
  og_image_width: seo.og_image_width || "",
  og_image_height: seo.og_image_height || "",
  og_image_alt: seo.og_image_alt || "",
  og_locale: seo.og_locale || "en_US",
  og_site_name: seo.og_site_name || "",

  twitter_card: seo.twitter_card || "summary_large_image",
  twitter_title: seo.twitter_title || "",
  twitter_description: seo.twitter_description || "",
  twitter_image: seo.twitter_image || "",
  twitter_image_alt: seo.twitter_image_alt || "",
  telugu_keywords: seo.telugu_keywords || "",
telugu_content: seo.telugu_content || "",
faq_schema: seo.faq_schema || "",
robots_content: seo.robots_content || "index, follow",
schema_markup: seo.schema_markup || "",
});

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDelete = async (id) => {
    try {
      await fetch(`https://admin.drgargevascular.com/backend/seo/${id}`, {
        method: "DELETE",
      });

      setSeoList((prev) => prev.filter((item) => item.id !== id));

      if (editingId === id) {
        resetForm();
      }

      showMessage("SEO deleted successfully!", "success");
    } catch (error) {
      console.error("Error deleting SEO:", error);
      showMessage("Error deleting SEO.", "error");
    }
  };

  const getDisplayName = (seo) => {
    if (seo.type === "page") return seo.page || "No Page";
    if (seo.type === "service") return `Service: ${seo.reference}`;
    if (seo.type === "blog") return `Blog: ${seo.reference}`;
    return "Unknown";
  };

  return (
    <>
      <PageTitle activeMenu="SEO Settings" motherMenu="Dashboard" />

      <div className="row">
        {/* ================= FORM ================= */}
        <div className="col-xl-12">
          <div className="card shadow-sm border-0">
            <div className="card-header d-flex justify-content-between align-items-center bg-white border-bottom">
              <h4 className="mb-0 fw-bold">
                {editingId ? "Edit SEO Settings" : "Add SEO Settings"}
              </h4>

              {editingId && (
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  onClick={resetForm}
                >
                  Cancel Edit
                </button>
              )}
            </div>

            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  {/* SEO TYPE */}
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">SEO Type</label>
                    <select
                      name="type"
                      className="form-control"
                      value={form.type}
                      onChange={handleChange}
                      required
                    >
                      <option value="page">Main Page</option>
                      <option value="service">Service Inner Page</option>
                      <option value="blog">Blog Inner Page</option>
                    </select>
                  </div>

                  {/* PAGE SELECT */}
                  {form.type === "page" && (
                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold">Select Page</label>
                      <select
                        name="page"
                        className="form-control"
                        value={form.page}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Page</option>
                        {pageOptions.map((page) => (
                          <option key={page} value={page}>
                            {page.charAt(0).toUpperCase() + page.slice(1)}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {/* SERVICE/BLOG REFERENCE */}
                  {form.type !== "page" && (
                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold">
                       {form.type === "service" ? "Service Slug" : "Blog Slug"}
                      </label>
                      <input
                        type="text"
                        name="reference"
                        className="form-control"
                        placeholder={
  form.type === "service"
    ? "example: varicose-veins"
    : "example: best-varicose-veins-treatment"
}
                        value={form.reference}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  )}

                  {/* META TITLE */}
                  <div className="col-md-12 mb-3">
                    <label className="form-label fw-bold">Meta Title</label>
                    <input
                      type="text"
                      name="meta_title"
                      className="form-control"
                      placeholder="Enter meta title"
                      value={form.meta_title}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* META DESCRIPTION */}
                  <div className="col-md-12 mb-3">
                    <label className="form-label fw-bold">Meta Description</label>
                    <textarea
                      name="meta_description"
                      className="form-control"
                      rows="4"
                      placeholder="Enter meta description"
                      value={form.meta_description}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  {/* META KEYWORDS */}
                  <div className="col-md-12 mb-3">
                    <label className="form-label fw-bold">Meta Keywords</label>
                    <textarea
                      name="meta_keywords"
                      className="form-control"
                      rows="3"
                      placeholder="Example: vascular doctor, varicose veins, piles treatment"
                      value={form.meta_keywords}
                      onChange={handleChange}
                    ></textarea>
                  </div>
<hr className="my-4" />

<h4 className="mb-4">Open Graph Tags</h4>

<div className="col-md-6 mb-3">
  <label className="form-label fw-bold">OG Type</label>
  <input
    type="text"
    name="og_type"
    className="form-control"
    value={form.og_type}
    onChange={handleChange}
    placeholder="website"
  />
</div>

<div className="col-md-6 mb-3">
  <label className="form-label fw-bold">OG URL</label>
  <input
    type="text"
    name="og_url"
    className="form-control"
    value={form.og_url}
    onChange={handleChange}
    placeholder="https://example.com"
  />
</div>

<div className="col-md-12 mb-3">
  <label className="form-label fw-bold">OG Title</label>
  <input
    type="text"
    name="og_title"
    className="form-control"
    value={form.og_title}
    onChange={handleChange}
  />
</div>

<div className="col-md-12 mb-3">
  <label className="form-label fw-bold">OG Description</label>
  <textarea
    name="og_description"
    className="form-control"
    rows="3"
    value={form.og_description}
    onChange={handleChange}
  />
</div>

<div className="col-md-12 mb-3">
  <label className="form-label fw-bold">OG Image URL</label>
  <input
    type="text"
    name="og_image"
    className="form-control"
    value={form.og_image}
    onChange={handleChange}
  />
</div>

<div className="col-md-4 mb-3">
  <label className="form-label fw-bold">OG Image Width</label>
  <input
    type="text"
    name="og_image_width"
    className="form-control"
    value={form.og_image_width}
    onChange={handleChange}
    placeholder="1200"
  />
</div>

<div className="col-md-4 mb-3">
  <label className="form-label fw-bold">OG Image Height</label>
  <input
    type="text"
    name="og_image_height"
    className="form-control"
    value={form.og_image_height}
    onChange={handleChange}
    placeholder="630"
  />
</div>

<div className="col-md-4 mb-3">
  <label className="form-label fw-bold">OG Locale</label>
  <input
    type="text"
    name="og_locale"
    className="form-control"
    value={form.og_locale}
    onChange={handleChange}
    placeholder="en_US"
  />
</div>

<div className="col-md-6 mb-3">
  <label className="form-label fw-bold">OG Image Alt</label>
  <input
    type="text"
    name="og_image_alt"
    className="form-control"
    value={form.og_image_alt}
    onChange={handleChange}
  />
</div>

<div className="col-md-6 mb-3">
  <label className="form-label fw-bold">OG Site Name</label>
  <input
    type="text"
    name="og_site_name"
    className="form-control"
    value={form.og_site_name}
    onChange={handleChange}
  />
</div>

<hr className="my-4" />

<h4 className="mb-4">Twitter Tags</h4>

<div className="col-md-6 mb-3">
  <label className="form-label fw-bold">Twitter Card</label>
  <input
    type="text"
    name="twitter_card"
    className="form-control"
    value={form.twitter_card}
    onChange={handleChange}
    placeholder="summary_large_image"
  />
</div>

<div className="col-md-12 mb-3">
  <label className="form-label fw-bold">Twitter Title</label>
  <input
    type="text"
    name="twitter_title"
    className="form-control"
    value={form.twitter_title}
    onChange={handleChange}
  />
</div>

<div className="col-md-12 mb-3">
  <label className="form-label fw-bold">Twitter Description</label>
  <textarea
    name="twitter_description"
    className="form-control"
    rows="3"
    value={form.twitter_description}
    onChange={handleChange}
  />
</div>

<div className="col-md-12 mb-3">
  <label className="form-label fw-bold">Twitter Image URL</label>
  <input
    type="text"
    name="twitter_image"
    className="form-control"
    value={form.twitter_image}
    onChange={handleChange}
  />
</div>

<div className="col-md-12 mb-3">
  <label className="form-label fw-bold">Twitter Image Alt</label>
  <input
    type="text"
    name="twitter_image_alt"
    className="form-control"
    value={form.twitter_image_alt}
    onChange={handleChange}
  />
</div>

<hr className="my-4" />

<h4 className="mb-4">Advanced SEO</h4>

<div className="col-md-12 mb-3">
  <label className="form-label fw-bold">
    Telugu Keywords
  </label>

  <textarea
    name="telugu_keywords"
    className="form-control"
    rows="3"
    placeholder="వెరికోస్ వీన్స్ చికిత్స హైదరాబాద్"
    value={form.telugu_keywords}
    onChange={handleChange}
  ></textarea>
</div>

<div className="col-md-12 mb-3">
  <label className="form-label fw-bold">
    Telugu SEO Content
  </label>

  <textarea
    name="telugu_content"
    className="form-control"
    rows="5"
    placeholder="డాక్టర్ షైలేష్ గార్గే..."
    value={form.telugu_content}
    onChange={handleChange}
  ></textarea>
</div>

<div className="col-md-12 mb-3">
  <label className="form-label fw-bold">
    FAQ Schema
  </label>

  <textarea
    name="faq_schema"
    className="form-control"
    rows="6"
    placeholder='{"@context":"https://schema.org"}'
    value={form.faq_schema}
    onChange={handleChange}
  ></textarea>
</div>

<div className="col-md-6 mb-3">
  <label className="form-label fw-bold">
    Robots Meta
  </label>

  <input
    type="text"
    name="robots_content"
    className="form-control"
    placeholder="index, follow"
    value={form.robots_content}
    onChange={handleChange}
  />
</div>

<div className="col-md-12 mb-3">
  <label className="form-label fw-bold">
    Schema Markup
  </label>

  <textarea
    name="schema_markup"
    className="form-control"
    rows="6"
    placeholder='{"@type":"MedicalClinic"}'
    value={form.schema_markup}
    onChange={handleChange}
  ></textarea>
</div>
                  {/* MESSAGE */}
                  {message && (
                    <div className="col-md-12">
                      <div
                        className={`alert ${
                          messageType === "success"
                            ? "alert-success"
                            : "alert-danger"
                        }`}
                        style={{
                          fontSize: "14px",
                          borderRadius: "8px",
                          padding: "10px 15px",
                        }}
                      >
                        {message}
                      </div>
                    </div>
                  )}

                  {/* BUTTONS */}
                  <div className="col-md-12 mt-2">
                    <button className="btn btn-primary me-2 px-4">
                      {editingId ? "Update SEO" : "Save SEO"}
                    </button>

                    {editingId && (
                      <button
                        type="button"
                        className="btn btn-outline-secondary px-4"
                        onClick={resetForm}
                      >
                        Cancel
                      </button>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* ================= LIST ================= */}
        <div className="col-xl-12 mt-4">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-white border-bottom">
              <h4 className="mb-0 fw-bold">All SEO Settings</h4>
            </div>

            <div className="card-body">
              {seoList.length > 0 ? (
                <div className="row">
                  {seoList.map((seo) => (
                    <div className="col-lg-6 mb-4" key={seo.id}>
                      <div
                        className="border rounded p-3 h-100"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <div className="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-2">
                          <span className="badge badge-primary">
                            {seo.type || "page"}
                          </span>

                          <span
                            style={{
                              fontSize: "12px",
                              color: "#666",
                              fontWeight: "500",
                            }}
                          >
                            {getDisplayName(seo)}
                          </span>
                        </div>

                        <h5 className="mb-2">{seo.meta_title || "No Title"}</h5>

                        <p
                          style={{
                            fontSize: "13px",
                            color: "#666",
                            minHeight: "60px",
                          }}
                        >
                          {seo.meta_description
                            ? seo.meta_description.substring(0, 150) + "..."
                            : "No description available"}
                        </p>

                        <p
                          style={{
                            fontSize: "12px",
                            color: "#999",
                            minHeight: "40px",
                          }}
                        >
                          <strong>Keywords:</strong>{" "}
                          {seo.meta_keywords || "No keywords added"}
                        </p>

                        <div className="mt-3 d-flex gap-2 flex-wrap">
                          <button
                            type="button"
                            onClick={() => handleEdit(seo)}
                            className="btn btn-warning btn-sm px-3"
                            style={{
                              minWidth: "80px",
                              height: "36px",
                            }}
                          >
                            Edit
                          </button>

                          <button
                            type="button"
                            onClick={() => handleDelete(seo.id)}
                            className="btn btn-danger btn-sm px-3"
                            style={{
                              minWidth: "80px",
                              height: "36px",
                            }}
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-5 text-muted">
                  No SEO settings found.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SeoDashboard;